import React, {useState} from 'react';
import NewContactPostalAddressRow from "./components/new-contact-postal-address-row";

function NewContactPostalAddressRows () {

    let defaultPostalAddresses = [{
        "id": "0",
        "city": "",
	    "neighborhood": "",
        "formattedAddress": "",
        "label": "",
        "postCode": "",
	    "street": "",
	    "countryCode": "",
	    "state": ""
    }];

    const [postalAddressRows, setPostalAddressRows] = useState(defaultPostalAddresses);

    const handleNewPostalAddressRow = () => {
        setPostalAddressRows([
            ...postalAddressRows,
            {
                "id": (parseInt(postalAddressRows[postalAddressRows.length - 1].id, 10) + 1).toString(),
                "city": "",
	            "neighborhood": "",
                "formattedAddress": "",
                "label": "",
                "postCode": "",
	            "street": "",
	            "countryCode": "",
	            "state": ""
            }
        ])
    };

    const handleDeletePostalAddressRow = (e) => {
        setPostalAddressRows(postalAddressRows.filter((postalAddressRow, index) => parseInt(e.currentTarget.dataset.index, 10) !== index));
    };

    return (
        <div className="new-contact-postal-address-rows border-top py-3">
            {
                postalAddressRows.map((postalAddress, index) => (
                    <NewContactPostalAddressRow
                        key={postalAddress.id}
                        postalAddress={postalAddress}
                        index={index}
                        newPostalAddressRow={handleNewPostalAddressRow}
                        deletePostalAddressRow={handleDeletePostalAddressRow}
                    />
                ))
            }
        </div>
    )

}

export default NewContactPostalAddressRows;
